import { Typography } from "@material-ui/core";
import { useRecordContext } from "ra-core";

const PaymentChannelField = (props) => {
  const { source } = props;
  const record = useRecordContext(props);
  return (
    <>
      {record[source]?.map((channel) => {
        return <Typography>{channel.type}</Typography>;
      })}
    </>
  );
};

export default PaymentChannelField;
